const MEMBER_SERVICES_EMAIL = 'memberservices@kingdomadvisors.com';

export function ContactEmailFallback() {
  return (
    <p
      style={{
        margin: '12px 0 0',
        textAlign: 'center',
        fontSize: '14px',
        color: '#6b7280',
        fontFamily: 'inherit',
        lineHeight: 1.5,
      }}
    >
      Or email us at{' '}
      <a
        href={`mailto:${MEMBER_SERVICES_EMAIL}`}
        style={{
          color: '#213C72',
          fontWeight: 500,
          textDecoration: 'underline',
          textUnderlineOffset: '2px',
        }}
      >
        {MEMBER_SERVICES_EMAIL}
      </a>
    </p>
  );
}
